import { createToast, ToastType, ToastTypeConfig } from 'hooks/useToast';
import { toast } from 'react-toastify';
import { toTitleCase } from 'utils/lodash';

/**
 * @deprecated This toast handler is deprecated. Please use the useToast hook directly from src/hooks/useToast.tsx.
 */

const createToastConfig = ({ type, title }: ToastTypeConfig) =>
  createToast(type, title);

/**
 * @deprecated This toast handler is deprecated. Please use the useToast hook directly from src/hooks/useToast.tsx.
 */
export const successToast = createToastConfig({
  type: ToastType.SUCCESS,
  title: toTitleCase(ToastType.SUCCESS),
});

/**
 * @deprecated This toast handler is deprecated. Please use the useToast hook directly from src/hooks/useToast.tsx.
 */
export const errorToast = createToastConfig({
  type: ToastType.ERROR,
  title: toTitleCase(ToastType.ERROR),
});

/**
 * @deprecated This toast handler is deprecated. Please use the useToast hook directly from src/hooks/useToast.tsx.
 */
export const infoToast = createToastConfig({
  type: ToastType.INFO,
  title: toTitleCase(ToastType.INFO),
});

/**
 * @deprecated This toast handler is deprecated. Please use the useToast hook directly from src/hooks/useToast.tsx.
 */
export const warningToast = createToastConfig({
  type: ToastType.WARNING,
  title: toTitleCase(ToastType.WARNING),
});

/**
 * @deprecated This toast handler is deprecated. Please use the useToast hook directly from src/hooks/useToast.tsx.
 */
export const dismissToast = (toastId = 'info') => toast.dismiss(toastId);
